import React, {Component} from 'react'
import {connect} from 'react-redux'
import {reduxForm, Form, Field, submit} from 'redux-form'
import {actions as notifActions} from 'redux-notifications'
import {Modal} from 'react-bootstrap'

import {entityFetcher} from './../../utils/entityFetcher'
import {getMessage} from './../../utils/i18n'
import {getUserProperty} from './../../utils/userProfile'
import boFetch from './../../utils/request'
import './changePassword.css'

const renderField = ({
                         input,
                         input: {name},
                         label,
                         meta: {touched, error},
                         goodMessage
                     }) => {
    return <div className="foChangePasswordFieldWrapper">
        <input {...input}
               name={name}
               className="foChangePasswordInput"
               type="password"
               placeholder={label}
               autoComplete="off"
        />
    </div>;
};

const relationValidator = (vals) => {
    const {currentPassword, newPassword, reenterPassword} = vals;
    const errors = {};

    currentPassword && currentPassword.trim().length && (currentPassword === newPassword) &&
    Object.assign(errors, {newPassword: getMessage("change-password.error.same-password")});

    (newPassword !== reenterPassword) &&
    Object.assign(errors, {reenterPassword: getMessage("change-password.error.reenter-password")});
    return errors;
};

class ChangePassword extends Component {

    constructor(props) {
        super(props);
        this.pendingRequests = {};
        this.state = {
          pwdpolicy: null
        };
    };

    registerRequest(token) {
        token = token ? token : new Date().getTime();
        return (cancelFunc) => {
            Object.assign(this.pendingRequests, {[token]: cancelFunc});
        };
    };

    cancelPendingRequests() {
        Object.keys(this.pendingRequests).forEach((token) => {
            this.pendingRequests[token]();
            delete this.pendingRequests[token];
        });
    };

    handleSubmit(data) {
        const {dispatch, history} = this.props;
        const requestToken = new Date().getTime();
        const fetcher = entityFetcher.create({
            api: `fo/change/password`,
            data: {
                userId: getUserProperty('id'),
                userName: getUserProperty('username'),
                password: data.newPassword,
                originalPassword: data.currentPassword
            },
            cancelToken: this.registerRequest(requestToken)
        });
        return fetcher.then(
            json => {
                delete this.pendingRequests[requestToken];
                dispatch(notifActions.notifSend({
                    kind: 'success',
                    message: getMessage('change-password.message.success')
                }));
                history.push('/');
            },
            e => {
                delete this.pendingRequests[requestToken];
                dispatch(notifActions.notifSend({
                    kind: 'danger',
                    message: getMessage('change-password.message.fail')
                }));
            }
        );
    }

    onHide() {
        if (!this.props.submitting) {
            this.props.history.push('/');
        }
    }

    disabledOrNot() {
        const {submitting, invalid} = this.props;
        return submitting || invalid;
    }

    setpwdpolicy(pwdpolicy){
        var pwdpolicyinfo = '';
        if (pwdpolicy.lengthCheck) pwdpolicyinfo += getMessage('change-password.pwdpolicy.lengthcheck',[pwdpolicy.minLength, pwdpolicy.maxLength]);
        if (pwdpolicy.upperAndLowerCase || pwdpolicy.numerical || pwdpolicy.specialChar) {
            pwdpolicyinfo += getMessage('change-password.pwdpolicy.contain');
            if (pwdpolicy.upperAndLowerCase) pwdpolicyinfo += getMessage('change-password.pwdpolicy.upperAndLowerCase');
            if (pwdpolicy.numerical) {if (pwdpolicy.upperAndLowerCase) pwdpolicyinfo += ", "; pwdpolicyinfo += getMessage('change-password.pwdpolicy.numerical');}
            if (pwdpolicy.specialChar) {if (pwdpolicy.upperAndLowerCase || pwdpolicy.numerical) pwdpolicyinfo += ", "; pwdpolicyinfo += getMessage('change-password.pwdpolicy.specialChar');}
            pwdpolicyinfo += ". "
        }
        if (pwdpolicy.historyCheck) pwdpolicyinfo += getMessage('change-password.pwdpolicy.historyCheck');
        this.setState({pwdpolicy:pwdpolicyinfo});
    }
    componentWillUnmount() {
        this.cancelPendingRequests();
    }

    componentWillMount(){
        var passwordPolicyUrl = '/bo/rest/entities/account/' + getUserProperty("accountId") +'/passwordpolicy';
        const requestToken = new Date().getTime();
        boFetch(
            {
                url: passwordPolicyUrl,
                cancelToken: this.registerRequest(requestToken)
            }
        ).then(pwdpolicy => {
            delete this.pendingRequests[requestToken];

            this.setpwdpolicy(pwdpolicy)
        }).catch(e => {
            console.log(e);
        });

    }

    render() {
        const {dispatch, form, submitting} = this.props;
        return (
            <Modal backdrop="static" show={true} onHide={this.onHide.bind(this)} id="changePasswordModal">
                <Modal.Header closeButton={!submitting}>
                    <Modal.Title>{getMessage("change-password.title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={this.props.handleSubmit(this.handleSubmit.bind(this))}>
                    </Form>
                    <Field name="currentPassword"
                           label={getMessage("change-password.label.current-password")}
                           component={renderField}
                           props={{goodMessage: null}}
                    />
                    <Field name="newPassword"
                           label={getMessage("change-password.label.new-password")}
                           component={renderField}
                           props={{goodMessage: getMessage("change-password.message.good")}}
                    />
                    <Field name="reenterPassword"
                           label={getMessage("change-password.label.reenter-password")}
                           component={renderField}
                           props={{goodMessage: getMessage("change-password.message.good")}}
                    />
                    <div>{this.state.pwdpolicy}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="foPrimaryButton"
                            onClick={() => dispatch(submit(form))}
                            disabled={this.disabledOrNot()}>
                        {getMessage("app.action.submit")}
                    </button>
                    <button className="foNormalButton"
                            onClick={this.onHide.bind(this)}
                            disabled={submitting}>
                        {getMessage("app.action.cancel")}
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

ChangePassword = reduxForm({
    form: 'resetPassword',
    destroyOnUnmount: true,
    validate: relationValidator
})(ChangePassword);

connect(null)(ChangePassword);

export default ChangePassword


// WEBPACK FOOTER //
// ./src/app/containers/changePassword/index.js